import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  bankNameSource = new BehaviorSubject<string>(localStorage.getItem('bankName'));
  bankName$ = this.bankNameSource.asObservable();
  bankBackgrounds: { [key: string]: string } = {
    pnb: 'linear-gradient(130deg, rgba(112, 12, 39, 0.8) 1%, rgba(178, 20, 63, 0.8) 6%, rgba(178, 20, 63, 0.8) 50%, rgba(255, 188, 9, 0.8) 100%)',
    iob: 'linear-gradient(130deg, rgba(52, 141, 229, 0.8) 1%, rgba(88, 152, 217, 0.8) 50%, rgba(100, 180, 255, 0.8) 100%)'
  };
  defaultBackground = '';
  defaultTitle = '';

  bankBackgroundSource = new BehaviorSubject<string>(this.bankBackgrounds[localStorage.getItem('bankName')]);
  bankBackground$ = this.bankBackgroundSource.asObservable();

  setBankName(bankName: string): void {
    localStorage.setItem('bankName', bankName);
    this.bankNameSource.next(bankName);
    this.bankNameSource.value
    console.log('BankName setup ', this.bankNameSource.value);
    this.setBankBackground(bankName);
  }

  setBankBackground(bankName: string): void {
    const background = this.getBankBackground(bankName);
    this.bankBackgroundSource.next(background);
    this.bankNameSource.value
  }

  getBankBackground(bankName: string | null): string {
    return this.bankBackgrounds[bankName] || this.defaultBackground;
  }

  getDefaultTitle() {
    return this.defaultTitle;
  }
}